import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import * as viewCaseDetailsActions from "../../store/actions/cases/viewCaseDetailsActions";
import * as CreateCaseActions from "../../store/actions/cases/createCaseActions";
import AddAttachmentImpl from "./AddAttachmentImpl";
import { useTranslation } from "react-i18next";
import { CPButton, CustomisedTertiaryButton, TextWrapper, Wrapper } from "../../constants/common/StyledGlobalConstants";
import CPNotification from "../../pages/Login/CPNotification";
import { useSnackbar } from "react-simple-snackbar";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET, DESKTOP, LARGE_DESKTOP } = DEVICE_BREAKPOINTS;

const AddCommentInput = styled.textarea`
  resize: vertical;
  border: ${(props) => (props.disabled ? "1px solid #E0E0E0" : " 1px solid #e0e0e0 !important")};
  background: ${(props) => (props.disabled ? "#f2f2f2" : " ")};

  border-radius: 4px;
  max-width: 100%;
  padding: 12px 16px 12px 16px;
  font-family: "neue-haas-grotesk-text";
  font-size: 14px;
  width: 100%;
  height: auto;
  &:hover {
    border: ${(props) => (props.disabled ? "1px solid #E0E0E0" : "1px solid #0077B4 !important")};
    border-radius: ${(props) => (props.disabled ? "" : "4px")};
    border: 1px solid #e0e0e0;
  }
  &:focus {
    border: 2px solid #0077b4 !important;
    border-radius: 4px;
  }
  &:focus-visible {
    border: 2px solid #0077b4 !important;
    outline: none;
  }
  &:active {
    border: 2px solid #0077b4 !important;
    border-radius: 4px;
  }

  &::placeholder {
    color: #747474;
    font-family: neue-haas-grotesk-text;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;

    // position: absolute;
    // top: 50%;
    // left: 10%;
    // transform: translate(-50%, -50%);
  }
  &::-webkit-scrollbar-track {
    background-color: #e2e2e2;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 100px;
    background-color: #bbb;
  }
`;

export const SnackBarButton = styled(CPButton)`
  & span {
    color: #0089ec;
  }
  &:hover {
    background-color: #002c4d;
  }
  &:focus {
    background-color: #ffffff;
    outline: 2px solid #0089ec !important;
  }
`;

function AddComment(props) {
  const caseId = props.caseId;

  const getMargin = () => {
    if (props.regionId === "840" || props.regionId === "124") {
      if (props.windowSize.width < 710) return "4rem";
      else return "0";
    } else {
      return "0";
    }
  };
  const [openSnackbar] = useSnackbar({
    position: "bottom-center",
    style: {
      borderRadius: "4px",
      boxShadow: "0px 1px 16px 0px rgba(0, 0, 0, 0.25)",
      backgroundColor: "#000000",
      fontFamily: "neue-haas-grotesk-text",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "20px",
      textAlign: "center",
      marginBottom: `${getMargin()}`,
    },
    closeStyle: {
      display: "none",
    },
  });
  const { t } = useTranslation("casesTranslation");
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [isResetAttachedFiles, setIsResetAttachedFiles] = useState(false);
  const [commentAttempt, setCommentAttempt] = useState(0);
  const [filesWithInvalidFilename, setFilesWithInvalidFilename] = useState(false);

  const handleCancel = () => {
    filesWithInvalidFilename && setFilesWithInvalidFilename(false);
    props.setComments("");
    setIsResetAttachedFiles(true);
    setTimeout(() => {
      props.firstActivityRef.current.focus();
    }, 100);
  };

  useEffect(() => {
    props.reset();
    return () =>
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
  }, []);
  useEffect(() => {
    if (props.commentAttachmentError) {
      props.resetCommentAttachment();

      if (commentAttempt < 1) {
        openSnackbar(
          <Wrapper fontFamily="neue-haas-grotesk-text" role="alert" display="grid" gridTemplateColumns="auto auto" alignItems="center">
            {t("Submission failed.")}
            <SnackBarButton
              padding="8px 16px"
              boxButton={true}
              fontSize="12px"
              buttonWidth={"auto"}
              buttonHeight="32px"
              id="try-again-button"
              onClick={handleTryAgain}
              fontPaddingLeft="0"
              fontPaddingRight="0"
              tabIndex="-1"
            >
              {t("TRY AGAIN")}
            </SnackBarButton>
          </Wrapper>,
          10000
        );
      } else
        openSnackbar(
          <p role="alert" style={{ margin: "0" }}>
            {t("Something has gone wrong. Try again later.")}
          </p>,
          4000
        );
    }
  }, [props.commentAttachmentError, commentAttempt]);

  useEffect(() => {
    if (props.comments || props.commentAttachmentCheck) {
      if (props.disableSubmit) {
        props.setCommentsSubmit(false);
      }
    } else if (!props.disableSubmit) {
      props.setCommentsSubmit(true);
    }
    if (props.comments || props.commentAttachmentCheck) {
      if (props.cancelCommentDisable) {
        props.setDisableCommentCancel(false);
      }
    } else if (!props.cancelCommentDisable) {
      props.setDisableCommentCancel(true);
    }
  }, [props.comments, props.commentAttachmentCheck]);

  const handleFields = (value) => {
    setIsResetAttachedFiles(false);
    props.setComments(value);
  };

  const handleTryAgain = () => {
    let attempt = commentAttempt;
    attempt++;
    setCommentAttempt(attempt);
    props.addComment();
  };

  const handleCommentSubmit = () => {
    filesWithInvalidFilename && setFilesWithInvalidFilename(false);
    if (props.comments && !props.commentAttachmentCheck) {
      props.addComment();
    } else if (!props.comments && props.commentAttachmentCheck) {
      props.setSubmitCommentAttachment(true);
    } else if (props.comments && props.commentAttachmentCheck) {
      props.addComment();
    }
  };


  return (
    <>
      {filesWithInvalidFilename && (
        <Wrapper marginTop="1rem">
          <CPNotification notificationType="error" isOpen={true} width="auto" height="auto">
            <Wrapper fontSize="0.875rem" fontFamily="neue-haas-grotesk-text">
              <TextWrapper fontWeight="bold">{t("The file name contains special characters")}</TextWrapper>
              <TextWrapper margin="0.7rem 0rem 0rem 0rem">
                {t("The name of the selected file contains special characters and cannot be uploaded.")}
              </TextWrapper>
              <TextWrapper>{t("Rename the file using letters, numbers and the following characters only !-_.'()")}</TextWrapper>
            </Wrapper>
          </CPNotification>
        </Wrapper>
      )}
      <Wrapper marginTop="1.5rem">
        <AddCommentInput
          type="text"
          label=""
          ariaLabel="Add a comment"
          required
          value={props.commentsLoading === true ? "" : props.comments}
          onChange={(event) => handleFields(event.target.value)}
          width="100%"
          placeholder={t("Add a comment")}
          onFocus={() => setIsInputFocused(true)}
          onBlur={() => setIsInputFocused(false)}
          disabled={props.requestClosure}
        ></AddCommentInput>
        <Wrapper marginTop="1rem">
          <AddAttachmentImpl
            isResetAttachedFiles={isResetAttachedFiles}
            setIsResetAttachedFiles={() => setIsResetAttachedFiles(false)}
            commentCaseId={caseId}
            addComments={true}
            filesWithInvalidFilename={filesWithInvalidFilename}
            setFilesWithInvalidFilename={setFilesWithInvalidFilename}
          />
        </Wrapper>
        <Wrapper
          marginTop="1rem"
          marginBottom="0.5rem"
          display="grid"
          gap="1.5rem"
          gridTemplateColumns={props.windowSize.width >= DESKTOP && "auto auto"}
        >
          <Wrapper gridRow="1" gridColumn="1">
            <TextWrapper color="#747474" fontFamily="neue-haas-grotesk-text" fontSize="0.75rem" fontWeight="400" lineHeight="1.25rem">
              {t(`Up to 10 files, max 5 MB each. Supported file types: PDF, DOC, DOCX, PPT, PPTX, XLS, XLSX, NOTEBOOK, JPG, JPEG, PNG.`)}
            </TextWrapper>
          </Wrapper>
          {(isInputFocused || props.comments || props.commentAttachmentCheck) && !props.commentsLoading && (

            <Wrapper gridRow={props.windowSize.width < LARGE_DESKTOP ? "2" : "1"} gridColumn={props.windowSize.width < LARGE_DESKTOP ? "1" : "2"}>
              <Wrapper
                display="flex"
                justifyContent={props.windowSize.width >= LARGE_DESKTOP ? "flex-end" : "flex-start"}
                alignItems="flex-start"
                flexDirection={props.windowSize.width < TABLET ? "column-reverse" : "row"}
                gap="1rem"
                flexWrap="nowrap"
              >
                <CustomisedTertiaryButton
                  id="add-comment-cancel-button"
                  fontSize="12px"
                  buttonHeight="32px"
                  boxButton={true}
                  onClick={handleCancel}
                  disabled={props.cancelDisable}
                  buttonWidth={props.windowSize.width < TABLET ? "100%" : "auto"}
                >
                  {t("CANCEL")}
                </CustomisedTertiaryButton>
                <CPButton
                  id="add-comment-submit-button"
                  fontSize="12px"
                  buttonHeight="32px"
                  boxButton={true}
                  disabled={props.disableSubmit}
                  onClick={() => handleCommentSubmit()}
                  buttonWidth={props.windowSize.width < TABLET ? "100%" : "auto"}
                >
                  {t("SUBMIT")}
                </CPButton>
              </Wrapper>
            </Wrapper>

          )}
        </Wrapper>
      </Wrapper>
    </>
  );
}

const mapDispatchToProps = {
  setCommentsModal: viewCaseDetailsActions.setCommentsModal,
  setComments: viewCaseDetailsActions.setComments,
  setCommentErr: viewCaseDetailsActions.setCommentErr,
  setCommentsSubmit: viewCaseDetailsActions.setCommentsSubmit,
  setDisableCommentCancel: viewCaseDetailsActions.setDisableCommentCancel,
  setCancelModal: viewCaseDetailsActions.setCancelModal,
  reset: viewCaseDetailsActions.resetAddComments,
  setSubmitAttachment: CreateCaseActions.setSubmitAttachment,
  addComment: viewCaseDetailsActions.addComment,
  setCaseReplySuccess: viewCaseDetailsActions.setCaseReplySuccess,
  getAllViewCaseDetails: viewCaseDetailsActions.getAllViewCaseDetails,
  setSubmitCommentAttachment: viewCaseDetailsActions.setSubmitCommentAttachment,
  resetCommentAttachment: viewCaseDetailsActions.resetCommentAttachment,
};

const mapStateToProps = (state) => {
  return {
    commentAttachments: state.VIEWCASEDETAILS.commentAttachments,
    openCommentsModal: state.VIEWCASEDETAILS.openCommentsModal,
    comments: state.VIEWCASEDETAILS.comments,
    commentErr: state.VIEWCASEDETAILS.commentErr,
    disableSubmit: state.VIEWCASEDETAILS.disableSubmit,
    cancelDisable: state.VIEWCASEDETAILS.cancelDisable,
    openCancelModal: state.VIEWCASEDETAILS.openCancelModal,
    commentAttachmentError: state.VIEWCASEDETAILS.commentAttachmentError,
    commentAttachmentErrorMsg: state.VIEWCASEDETAILS.commentAttachmentErrorMsg,
    commentsLoading: state.VIEWCASEDETAILS.commentsLoading,
    caseId: state.VIEWCASEDETAILS.caseId,
    caseReplySuccess: state.VIEWCASEDETAILS.caseReplySuccess,
    cancelCommentDisable: state.VIEWCASEDETAILS.cancelCommentDisable,
    commentAttachmentCheck: state.VIEWCASEDETAILS.commentAttachmentCheck,
    windowSize: state.ACCOUNT.windowSize,
    userLanguage: state.ACCOUNT.userLanguage,
    regionId: state.ACCOUNT.regionId,
  };
};
AddComment.propTypes = {
  caseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setComments: PropTypes.func,
  reset: PropTypes.func,
  firstActivityRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  regionId: PropTypes.string,
  windowSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  comments: PropTypes.string,
  commentsLoading: PropTypes.bool,
  commentAttachmentCheck: PropTypes.bool,
  disableSubmit: PropTypes.bool,
  setCommentsSubmit: PropTypes.func,
  cancelCommentDisable: PropTypes.bool,
  setDisableCommentCancel: PropTypes.func,
  setSubmitCommentAttachment: PropTypes.func,
  addComment: PropTypes.func,
  commentAttachmentError: PropTypes.bool,
  resetCommentAttachment: PropTypes.func,
  requestClosure: PropTypes.bool,
  cancelDisable: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddComment);
